import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Login.css';
import axios from 'axios';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async(e) => {
    e.preventDefault();
    try {
    // const res =  await axios.post("http://localhost:5000/api/login", {
    //   email, password,
    // });

    const res = await axios.post("/api/login", { email, password });


   
    console.log('response', res.data);
    alert(res.data.message);
    console.log('Login attempt:', { email, password, rememberMe });
    localStorage.setItem('login', JSON.stringify(res.data.user));
    navigate('/dashboard');
  } catch(err) {
    console.error(err);
    alert('Login failed');
  }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Welcome Back</h1>
          <p>Please enter your credentials to login</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          <div className="form-options">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span>Remember me</span>
            </label>
            <a href="#" className="forgot-password">Forgot Password?</a>
          </div>

          <button type="submit" className="login-button" 
          //onClick={() => navigate('/dashboard')}
          >
            Sign In
          </button>
        </form>

        {/* <div className="login-footer">
          <p>Don't have an account? <a href="#">Sign Up</a></p>
        </div> */}
      </div>
    </div>
  );
};

export default Login;